import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store';

import { TABS } from './constants';
import Importer from './importer';

export default function ImporterIndex({
  activeTab,
  aggregateView,
  availableDatabases,
  currentUser,
  databaseId,
  databaseMembers,
  paths
}) {
  const store = configureStore({
    paths: paths,
    query: {
      importPage: 1,
      importRequestPage: 1
    },
    search: {
      imports: [],
      importRequests: [],
      isFetching: true,
      meta: {
        allIds: [],
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    },
    static: {
      aggregateView: aggregateView,
      availableDatabases: availableDatabases,
      currentUser: currentUser,
      databaseId: databaseId,
      databaseMembers: databaseMembers
    },
    ui: {
      activeTab: activeTab
    }
  });

  return (
    <Provider store={store}>
      <Importer />
    </Provider>
  );
}

ImporterIndex.propTypes = {
  activeTab: PropTypes.oneOf(Object.values(TABS)),
  aggregateView: PropTypes.bool.isRequired,
  availableDatabases: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  databaseId: PropTypes.number,
  databaseMembers: PropTypes.array.isRequired,
  paths: PropTypes.object
};

ImporterIndex.defaultProps = {
  activeTab: TABS.IMPORTS
};
